export function formatCurrency(price) {
    const currencyFormat = new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
    });
       
    return currencyFormat.format(price);
}